import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/404_images/404.png';
import _imports_1 from '@/assets/404_images/404_cloud.png';
const _withScopeId = n => (_pushScopeId("data-v-1429bacd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "error-container"
};
const _hoisted_2 = {
  class: "wscn-http404-container"
};
const _hoisted_3 = {
  class: "wscn-http404"
};
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"pic-404\" data-v-1429bacd><img class=\"pic-404__parent\" src=\"" + _imports_0 + "\" alt=\"404\" data-v-1429bacd><img class=\"pic-404__child left\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1429bacd><img class=\"pic-404__child mid\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1429bacd><img class=\"pic-404__child right\" src=\"" + _imports_1 + "\" alt=\"404\" data-v-1429bacd></div>", 1);
const _hoisted_5 = {
  class: "bullshit"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bullshit__oops"
}, " 404错误! ", -1));
const _hoisted_7 = {
  class: "bullshit__headline"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bullshit__info"
}, " 对不起，您正在寻找的页面不存在。尝试检查URL的错误，然后按浏览器上的刷新按钮或尝试在我们的应用程序中找到其他内容。 ", -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, _toDisplayString($options.message), 1), _hoisted_8, _createVNode(_component_router_link, {
    to: "/",
    class: "bullshit__return-home"
  }, {
    default: _withCtx(() => [_createTextVNode(" 返回首页 ")]),
    _: 1
  })])])])]);
}